/**
 * Fractalot App Router
 *
 * Uses store-based navigation. Views overlay on top of map.
 * The map (#leaflet) is never hidden - other views appear above it.
 */

import { store, actions, selectors } from "./store";

export function initApp(): void {
  // Subscribe to view changes - update UI when store changes
  store.select(selectors.currentView, (currentView) => {
    updateNavLinks(currentView);
    updateViewVisibility(currentView);
  });

  // Handle nav link clicks - update store (UI reacts automatically)
  document.querySelectorAll<HTMLElement>(".nav-link[data-view]").forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const view = link.dataset.view as "explorer" | "collection" | "gallery";
      if (view) actions.navigateTo(view);
    });
  });
}

/**
 * Update nav link active states
 */
function updateNavLinks(currentView: string): void {
  document.querySelectorAll(".nav-link").forEach((link) => {
    link.classList.toggle("active", link.getAttribute("data-view") === currentView);
  });
}

/**
 * Show/hide view pages based on current view
 * Explorer = hide all overlays (map is always visible)
 * Collection/Marketplace = show that overlay
 */
function updateViewVisibility(currentView: string): void {
  document.querySelectorAll(".view-page").forEach((el) => {
    if (currentView === "explorer") {
      el.classList.add("hidden");
    } else {
      const isTarget = el.id === `${currentView}View`;
      el.classList.toggle("hidden", !isTarget);
    }
  });

  // Hide explorer controls (render settings, shortcuts) when not on explorer
  const inputsWrapper = document.getElementById("inputsWrapper");
  if (inputsWrapper) {
    inputsWrapper.classList.toggle("hidden", currentView !== "explorer");
  }
}
